import enableDefaultOnlineMeeting from './enableDefaultOnlineMeeting';
import { clearOnlineMeeting } from 'owa-calendar-compose-form-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Updates the online meeting when the user adds or removes attendees
 * @param event
 */
export default function updateOnlineMeetingOnRecipientsChanged(event: CalendarEvent) {
    // Decides whether to enable the online meeting by default or not
    enableDefaultOnlineMeeting(event);

    // Decides whether to clear the online meeting or not
    // Applicable for quick compose when the user removes all attendees and the online meeting disappears
    clearOnlineMeeting(event);
}
